<template>
  <Transition name="slide-fade" appear>
    <div v-if="visible" class="modal">
      <div
          class="simulator-wrapper"
          :style="{
          transform: `translate(${position.x}px, ${position.y}px)`,
          position: 'fixed',
          top: '50%',
          left: '50%',
          marginLeft: '-170px',
          marginTop: '-350px'
        }"
      >
        <div
            class="simulator-header"
            @mousedown="startDrag"
            @touchstart="startDrag"
        >
          <div class="header-left">
            <button
                class="header-icon-button"
                :class="isPreviousQuestionDisabled && 'disabled'"
                :disabled="isPreviousQuestionDisabled"
                @click="handlePreviousQuestion"
            >
              <img src="@/assets/images/chevronLeft.svg" />
            </button>

            <span class="current-question-index">
              {{ currentQuestionIndex + 1 }}
            </span>

            <button
                class="header-icon-button"
                :class="isNextQuestionDisabled && 'disabled'"
                :disabled="isNextQuestionDisabled"
                @click="handleNextQuestion"
            >
              <img src="@/assets/images/chevronRight.svg" />
            </button>
          </div>

          <div class="header-center" />

          <div class="header-right">
            <img
                src="@/assets/images/crossCircle.svg"
                alt="Close"
                @click="onHide"
                class="close-icon"
            />
          </div>
        </div>

        <div class="preview-holder">
          <div class="preview-content">
            <div class="phone-header" :style="{
              backgroundColor: headerColor,
             }">
              <div class="header-left">
                <svg width="38" height="17" viewBox="0 0 38 17" fill="none" xmlns="http://www.w3.org/2000/svg" class="header-bar-clock">
                  <path
                      d="M6.3291 2.00098C7.00293 2.00098 7.64453 2.12695 8.25391 2.37891C8.86328 2.63086 9.40234 3.01758 9.87109 3.53906C10.3457 4.06055 10.7178 4.73145 10.9873 5.55176C11.2568 6.37207 11.3916 7.35352 11.3916 8.49609V8.51367C11.3916 9.9375 11.1865 11.1562 10.7764 12.1699C10.3662 13.1836 9.78027 13.96 9.01855 14.499C8.25684 15.0381 7.34277 15.3076 6.27637 15.3076C5.49707 15.3076 4.79395 15.167 4.16699 14.8857C3.5459 14.5986 3.03027 14.2061 2.62012 13.708C2.20996 13.21 1.9375 12.6387 1.80273 11.9941L1.78516 11.8975H4.00879L4.04395 11.9766C4.15527 12.2754 4.31348 12.5361 4.51855 12.7588C4.72949 12.9756 4.98145 13.1455 5.27441 13.2686C5.57324 13.3916 5.90723 13.4531 6.27637 13.4531C6.9502 13.4531 7.49805 13.2568 7.91992 12.8643C8.34766 12.4658 8.66699 11.9355 8.87793 11.2734C9.08887 10.6055 9.20898 9.86719 9.23828 9.05859C9.24414 8.9707 9.24707 8.88574 9.24707 8.80371C9.24707 8.71582 9.24707 8.63086 9.24707 8.54883L8.85156 6.43945C8.85156 5.95313 8.74023 5.5166 8.51758 5.12988C8.29492 4.7373 7.99316 4.42676 7.6123 4.19824C7.2373 3.96387 6.81543 3.84668 6.34668 3.84668C5.88379 3.84668 5.46191 3.96094 5.08105 4.18945C4.7002 4.41211 4.39551 4.71387 4.16699 5.09473C3.93848 5.47559 3.82422 5.90625 3.82422 6.38672V6.4043C3.82422 6.89062 3.93262 7.32422 4.14941 7.70508C4.36621 8.08008 4.66211 8.37598 5.03711 8.59277C5.41797 8.80957 5.8457 8.91797 6.32031 8.91797C6.80078 8.91797 7.23145 8.8125 7.6123 8.60156C7.99316 8.38477 8.29492 8.0918 8.51758 7.72266C8.74023 7.35352 8.85156 6.92871 8.85156 6.44824V6.43945H9.37891V8.75977H9.08008C8.92773 9.09375 8.70215 9.40723 8.40332 9.7002C8.10449 9.9873 7.73535 10.2188 7.2959 10.3945C6.85645 10.5703 6.34375 10.6582 5.75781 10.6582C4.94922 10.6582 4.23145 10.4766 3.60449 10.1133C2.9834 9.75 2.49707 9.25195 2.14551 8.61914C1.79395 7.98633 1.61816 7.27148 1.61816 6.47461V6.45703C1.61816 5.60156 1.81738 4.83691 2.21582 4.16309C2.62012 3.48926 3.17676 2.96191 3.88574 2.58105C4.60059 2.19434 5.41504 2.00098 6.3291 2.00098ZM14.8115 13.2949C14.4189 13.2949 14.0879 13.1631 13.8184 12.8994C13.5547 12.6299 13.4229 12.3018 13.4229 11.915C13.4229 11.5283 13.5547 11.2031 13.8184 10.9395C14.0879 10.6699 14.4189 10.5352 14.8115 10.5352C15.2158 10.5352 15.5498 10.6699 15.8135 10.9395C16.0771 11.2031 16.209 11.5283 16.209 11.915C16.209 12.3018 16.0771 12.6299 15.8135 12.8994C15.5498 13.1631 15.2158 13.2949 14.8115 13.2949ZM14.8115 6.77344C14.4189 6.77344 14.0879 6.6416 13.8184 6.37793C13.5547 6.1084 13.4229 5.78027 13.4229 5.39355C13.4229 5.00684 13.5547 4.68164 13.8184 4.41797C14.0879 4.14844 14.4189 4.01367 14.8115 4.01367C15.2158 4.01367 15.5498 4.14844 15.8135 4.41797C16.0771 4.68164 16.209 5.00684 16.209 5.39355C16.209 5.78027 16.0771 6.1084 15.8135 6.37793C15.5498 6.6416 15.2158 6.77344 14.8115 6.77344ZM24.4189 15V12.5654H18.2139V10.7109C18.542 10.1367 18.876 9.56543 19.2158 8.99707C19.5557 8.42285 19.8984 7.85156 20.2441 7.2832C20.5957 6.70898 20.9443 6.14355 21.29 5.58691C21.6416 5.02441 21.9902 4.4707 22.3359 3.92578C22.6875 3.38086 23.0361 2.84473 23.3818 2.31738H26.5811V10.6934H28.2949V12.5654H26.5811V15H24.4189ZM20.3145 10.7461H24.4541V4.12793H24.3311C24.0674 4.52637 23.7979 4.93652 23.5225 5.3584C23.2529 5.78027 22.9805 6.21094 22.7051 6.65039C22.4297 7.08984 22.1543 7.53223 21.8789 7.97754C21.6094 8.42285 21.3428 8.86816 21.0791 9.31348C20.8154 9.75293 20.5605 10.1895 20.3145 10.623V10.7461ZM33.0332 15V4.5498H32.8838L29.7285 6.77344V4.64648L33.042 2.31738H35.292V15H33.0332Z"
                      :fill="headerStyle === 'dark' ? '#000' : '#fff'"
                  />
                </svg>
              </div>

              <div class="dynamic-island" />

              <div class="header-right">
                <svg width="89" height="15" viewBox="0 0 89 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="header-bar-icons">
                  <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M21.7242 0.624851H20.3826C19.6416 0.624851 19.0409 1.20408 19.0409 1.9186V13.1311C19.0409 13.8456 19.6416 14.4248 20.3826 14.4248H21.7242C22.4652 14.4248 23.0659 13.8456 23.0659 13.1311V1.9186C23.0659 1.20408 22.4652 0.624851 21.7242 0.624851ZM14.0688 3.64375H15.4105C16.1514 3.64375 16.7521 4.22299 16.7521 4.9375V13.1312C16.7521 13.8458 16.1514 14.425 15.4105 14.425H14.0688C13.3278 14.425 12.7271 13.8458 12.7271 13.1312V4.9375C12.7271 4.22299 13.3278 3.64375 14.0688 3.64375ZM9.09676 6.66225H7.75509C7.01411 6.66225 6.41343 7.24149 6.41343 7.956V13.131C6.41343 13.8455 7.01411 14.4247 7.75509 14.4247H9.09676C9.83774 14.4247 10.4384 13.8455 10.4384 13.131V7.956C10.4384 7.24149 9.83774 6.66225 9.09676 6.66225ZM2.78306 9.24971H1.4414C0.700416 9.24971 0.0997314 9.82894 0.0997314 10.5435V13.131C0.0997314 13.8455 0.700416 14.4247 1.4414 14.4247H2.78306C3.52404 14.4247 4.12473 13.8455 4.12473 13.131V10.5435C4.12473 9.82894 3.52404 9.24971 2.78306 9.24971Z"
                      :fill="headerStyle === 'dark' ? '#000' : '#fff'"
                  />
                  <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M39.8414 3.32281C42.678 3.32294 45.4061 4.4391 47.4618 6.44061C47.6166 6.59513 47.864 6.59318 48.0165 6.43624L49.4963 4.90684C49.5735 4.82723 49.6165 4.71941 49.6159 4.60722C49.6153 4.49503 49.571 4.38773 49.4929 4.30906C44.0972 -0.986452 35.5849 -0.986452 30.1892 4.30906C30.111 4.38767 30.0666 4.49494 30.0659 4.60713C30.0652 4.71932 30.1082 4.82718 30.1853 4.90684L31.6655 6.43624C31.8179 6.59342 32.0655 6.59537 32.2202 6.44061C34.2762 4.43897 37.0046 3.3228 39.8414 3.32281ZM39.8414 8.29848C41.3999 8.29838 42.9028 8.89161 44.058 9.96291C44.2143 10.1149 44.4604 10.1117 44.6127 9.95548L46.0908 8.42608C46.1687 8.34585 46.2118 8.23703 46.2107 8.12394C46.2096 8.01085 46.1643 7.90295 46.0848 7.82436C42.5669 4.47316 37.1189 4.47316 33.601 7.82436C33.5215 7.90295 33.4762 8.01091 33.4752 8.12403C33.4741 8.23715 33.5175 8.34597 33.5955 8.42608L35.0731 9.95548C35.2254 10.1117 35.4716 10.1149 35.6278 9.96291C36.7823 8.89232 38.284 8.29914 39.8414 8.29848ZM42.8023 11.6465C42.8045 11.7599 42.761 11.8692 42.6819 11.9487L40.1252 14.5911C40.0502 14.6687 39.948 14.7124 39.8414 14.7124C39.7348 14.7124 39.6326 14.6687 39.5577 14.5911L37.0005 11.9487C36.9215 11.8692 36.878 11.7598 36.8804 11.6464C36.8827 11.533 36.9306 11.4256 37.0129 11.3496C38.6457 9.93527 41.0371 9.93527 42.67 11.3496C42.7521 11.4257 42.8 11.5331 42.8023 11.6465Z"
                      :fill="headerStyle === 'dark' ? '#000' : '#fff'"
                  />
                  <rect
                      opacity="0.4"
                      x="57.1908"
                      y="0.624926"
                      width="27.6"
                      height="13.8"
                      rx="4.025"
                      :stroke="headerStyle === 'dark' ? '#000' : '#fff'"
                      stroke-width="1.15"
                  />
                  <path
                      opacity="0.5"
                      d="M86.5158 5.22492V9.82492C87.4426 9.43533 88.0453 8.52902 88.0453 7.52492C88.0453 6.52082 87.4426 5.61451 86.5158 5.22492Z"
                      :fill="headerStyle === 'dark' ? '#000' : '#fff'"
                  />
                  <rect
                      x="58.9158"
                      y="2.34993"
                      width="19.55"
                      height="10.35"
                      rx="2.3"
                      :fill="headerStyle === 'dark' ? '#000' : '#fff'"
                  />
                </svg>
              </div>
            </div>

            <div class="phone-content">
              <div class="scrollable-area">
                <div class="content-header" v-if="headerEnabled">
                  <span class="content-title">{{truncate(getCurrentQuestion?.name, 35)}}</span>
                  <span class="content-description">{{ getNameFromType(getCurrentQuestion?.content?.type) }}</span>

                  <div class="progress-container">
                    <span class="progress-bar" :style="{
                      width: `${(currentQuestionIndex + 1) / testData?.questions?.length * 100}%`
                    }"></span>
                  </div>
                </div>

                <div class="content-body">
                  <SummaryType
                      v-if="getCurrentQuestion?.content?.type === 'summary' || getCurrentQuestion?.content?.type === 'welcomeText'"
                      :question-data="getCurrentQuestion"
                  />

                  <SingleType
                      v-else-if="getCurrentQuestion?.content?.type === 'single' || getCurrentQuestion?.content?.type === 'yesNo'"
                      :question-data="getCurrentQuestion"
                  />

                  <MultipleType
                      v-else-if="getCurrentQuestion?.content?.type === 'multiple'"
                      :question-data="getCurrentQuestion"
                  />

                  <FillTheBlankType
                      v-else-if="getCurrentQuestion?.content?.type === 'fillTheBlank'"
                      :question-data="getCurrentQuestion"
                  />

                  <NumberType
                      v-else-if="getCurrentQuestion?.content?.type === 'number'"
                      :question-data="getCurrentQuestion"
                  />

                  <TextType
                      v-else-if="getCurrentQuestion?.content?.type === 'text'"
                      :question-data="getCurrentQuestion"
                  />

                  <RatingType
                      v-else-if="getCurrentQuestion?.content?.type === 'rating'"
                      :question-data="getCurrentQuestion"
                  />

                  <GradingType
                      v-else-if="getCurrentQuestion?.content?.type === 'grading'"
                      :question-data="getCurrentQuestion"
                  />

                  <DragAndDropType
                      v-else-if="getCurrentQuestion?.content?.type === 'dragAndDrop'"
                      :question-data="getCurrentQuestion"
                  />

                  <MatchType
                      v-else-if="getCurrentQuestion?.content?.type === 'matchType'"
                      :question-data="getCurrentQuestion"
                  />

                  <SwipeType
                      v-else-if="getCurrentQuestion?.content?.type === 'swipe'"
                      :question-data="getCurrentQuestion"
                  />

                  <AudioType
                      v-else-if="getCurrentQuestion?.content?.type === 'audio'"
                      :question-data="getCurrentQuestion"
                  />

                  <VideoType
                      v-else-if="getCurrentQuestion?.content?.type === 'video'"
                      :question-data="getCurrentQuestion"
                  />

                  <SuccessType
                      v-else-if="getCurrentQuestion?.content?.type === 'success'"
                      :question-data="getCurrentQuestion"
                  />

                  <FailedType
                      v-else-if="getCurrentQuestion?.content?.type === 'failed'"
                      :question-data="getCurrentQuestion"
                  />

                  <div class="no-preview-available" v-else>
                    <span>No preview available for this type.</span>
                  </div>
                </div>
              </div>

              <div class="content-footer" v-if="footerEnabled">
                <button
                    class="prev-button"
                    :class="isPreviousQuestionDisabled && 'disabled'"
                    :disabled="isPreviousQuestionDisabled"
                    @click="handlePreviousQuestion"
                >
                  {{ $t("go_back_button") }}
                </button>

                <button
                    class="next-button"
                    :class="isNextQuestionDisabled && 'disabled'"
                    :disabled="isNextQuestionDisabled"
                    @click="handleNextQuestion"
                >
                  {{ $t("next") }}
                </button>
              </div>
            </div>

            <div
                class="phone-footer"
                :style="{backgroundColor: footerColor}"
            >
              <svg width="134" height="5" viewBox="0 0 134 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="134" height="5" rx="2.5" fill="#D2D6E0"/>
              </svg>
            </div>
          </div>

          <img src="@/assets/images/deviceMockup.png" class="phone-image"/>
        </div>
      </div>

    </div>
  </Transition>
</template>

<script>
import { ref, reactive, onMounted, onUnmounted } from 'vue'
import {getNameFromType, truncate} from "@/utils/utils";
import SummaryType from "@/components/preview-components/SummaryType.vue";
import MultipleType from "@/components/preview-components/MultipleType.vue";
import FillTheBlankType from "@/components/preview-components/FillTheBlankType.vue";
import NumberType from "@/components/preview-components/NumberType.vue";
import TextType from "@/components/preview-components/TextType.vue";
import GradingType from "@/components/preview-components/GradingType.vue";
import DragAndDropType from "@/components/preview-components/DragAndDropType.vue";
import MatchType from "@/components/preview-components/MatchType.vue";
import SwipeType from "@/components/preview-components/SwipeType.vue";
import AudioType from "@/components/preview-components/AudioType.vue";
import VideoType from "@/components/preview-components/VideoType.vue";
import SuccessType from "@/components/preview-components/SuccessType.vue";
import FailedType from "@/components/preview-components/FailedType.vue";
import SingleType from "@/components/preview-components/SingleType.vue";
import RatingType from "@/components/preview-components/RatingType.vue";

export default {
  name: 'ProgramPreviewModal',
  components: {
    RatingType,
    SingleType,
    FailedType,
    SuccessType,
    VideoType,
    AudioType,
    SwipeType,
    MatchType,
    DragAndDropType,
    GradingType,
    TextType,
    NumberType,
    FillTheBlankType,
    MultipleType,
    SummaryType
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    onHide: {
      type: Function,
      default: () => {}
    },
    testData: {
      type: Object,
      default: () => ({})
    }
  },
  setup() {
    const position = reactive({ x: 0, y: 0 })
    const isDragging = ref(false)
    const dragStartPosition = reactive({ x: 0, y: 0 })
    const initialPosition = reactive({ x: 0, y: 0 })

    const startDrag = (e) => {
      isDragging.value = true

      const clientX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX
      const clientY = e.type.includes('mouse') ? e.clientY : e.touches[0].clientY

      dragStartPosition.x = clientX
      dragStartPosition.y = clientY
      initialPosition.x = position.x
      initialPosition.y = position.y

      e.preventDefault()
    }

    const drag = (e) => {
      if (!isDragging.value) return

      const clientX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX
      const clientY = e.type.includes('mouse') ? e.clientY : e.touches[0].clientY

      const deltaX = clientX - dragStartPosition.x
      const deltaY = clientY - dragStartPosition.y

      // Calculate new position
      let newX = initialPosition.x + deltaX
      let newY = initialPosition.y + deltaY

      // Get viewport dimensions
      const viewportWidth = window.innerWidth
      const viewportHeight = window.innerHeight

      // Modal dimensions
      const modalWidth = 340
      const modalHeight = 700 // Approximate height of the phone simulator

      // Calculate current modal edges (considering center positioning and margins)
      const currentLeft = (viewportWidth / 2) - 170 + newX
      const currentTop = (viewportHeight / 2) - 350 + newY
      const currentRight = currentLeft + modalWidth
      const currentBottom = currentTop + modalHeight

      // Prevent modal from going outside viewport
      if (currentLeft < 0) {
        newX = -(viewportWidth / 2) + 170
      }
      if (currentRight > viewportWidth) {
        newX = (viewportWidth / 2) - 170
      }
      if (currentTop < 0) {
        newY = -(viewportHeight / 2) + 350
      }
      if (currentBottom > viewportHeight) {
        newY = (viewportHeight / 2) - 350
      }

      position.x = newX
      position.y = newY
    }

    const endDrag = () => {
      isDragging.value = false
    }

    // Reset position if modal goes completely out of bounds
    const checkBounds = () => {
      const viewportWidth = window.innerWidth
      const viewportHeight = window.innerHeight

      // If modal is completely outside viewport, reset to center
      if (Math.abs(position.x) > viewportWidth / 2 + 170 ||
          Math.abs(position.y) > viewportHeight / 2 + 350) {
        position.x = 0
        position.y = 0
      }
    }

    // Watch for window resize
    const handleResize = () => {
      checkBounds()
    }

    onMounted(() => {
      document.addEventListener('mousemove', drag)
      document.addEventListener('mouseup', endDrag)
      document.addEventListener('touchmove', drag, { passive: false })
      document.addEventListener('touchend', endDrag)
      window.addEventListener('resize', handleResize)
    })

    onUnmounted(() => {
      document.removeEventListener('mousemove', drag)
      document.removeEventListener('mouseup', endDrag)
      document.removeEventListener('touchmove', drag)
      document.removeEventListener('touchend', endDrag)
      window.removeEventListener('resize', handleResize)
    })

    return {
      position,
      startDrag
    }
  },
  data() {
    return {
      currentQuestionIndex: 0,
      headerColor: '#fff',
      headerStyle: 'dark',
      footerColor: '#fff',
      footerStyle: 'dark',
    }
  },
  mounted() {
    this.calculateHeaderColor();
  },
  methods: {
    getNameFromType,
    truncate,
    handleNextQuestion() {
      if (this.isNextQuestionDisabled) return;

      this.currentQuestionIndex++;
      this.calculateHeaderColor();
    },
    handlePreviousQuestion() {
      if (this.isPreviousQuestionDisabled) return;

      this.currentQuestionIndex--;
      this.calculateHeaderColor();
    },
    calculateHeaderColor() {
      if (!this.getCurrentQuestion) {
        return;
      }

      if (
          this.getCurrentQuestion.content?.type === 'audio' ||
          this.getCurrentQuestion.content?.type === 'success' ||
          this.getCurrentQuestion.content?.type === 'failed'
      ) {
        this.headerStyle = 'light';
      } else {
        this.headerStyle = 'dark';
      }

      if (this.getCurrentQuestion.content?.type === 'success') {
        this.headerColor = '#1cad79';
        this.footerColor = '#1cad79';
      }  else if (this.getCurrentQuestion.content?.type === 'failed') {
        this.headerColor = '#ed5f50';
        this.footerColor = '#ed5f50';
      } else if (this.getCurrentQuestion.content?.type === 'audio') {
        this.headerColor = 'transparent';
        this.footerColor = 'transparent';
      } else {
        this.headerColor = '#fff';
        this.footerColor = '#fff';
      }

    },
  },
  computed: {
    isNextQuestionDisabled() {
      return this.currentQuestionIndex >= (this.testData?.questions?.length || 0) - 1;
    },
    isPreviousQuestionDisabled() {
      return this.currentQuestionIndex <= 0;
    },
    getCurrentQuestion() {
      if (!this.testData || !this.testData.questions || this.testData.questions.length === 0) {
        return null;
      }

      return this.testData.questions[this.currentQuestionIndex];
    },
    headerEnabled() {
      return this.getCurrentQuestion && !['video', 'audio', 'success', 'failed'].includes(this.getCurrentQuestion.content?.type);
    },
    footerEnabled() {
      return this.getCurrentQuestion && !['video', 'audio', 'success', 'failed'].includes(this.getCurrentQuestion.content?.type);
    },
  }
}
</script>

<style scoped>
.modal {
  min-width: 400px;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  z-index: 99999;
}

.phone-image {
  width: 340px;
}

.preview-holder{
  justify-content: center;
  justify-items: center;
  align-items: center;
  align-self: center;
  display: flex;
  width: 340px;
  position: relative;
}

.preview-content {
  position: absolute;
  border-radius: 42px;
  left: 20px;
  right: 20px;
  top: 20px;
  bottom: 20px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.phone-header {
  height: 48px;
  width: 100%;
  background: #fff;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-shrink: 0;
}

.phone-header .header-left, .phone-header .header-right, .phone-header .dynamic-island {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.header-bar-clock {
  height: 14px;
  z-index: 1;
}

.phone-image{
  height: 100%;
  position: relative;
}

.header-bar-icons {
  height: 11px;
  z-index: 1;
}

.phone-content {
  flex: 1;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
  z-index:9999;
}

.scrollable-area {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
}

.scrollable-area::-webkit-scrollbar {
  display: none;
}

/* Firefox için */
.scrollable-area {
  scrollbar-width: none;
  -ms-overflow-style: none; /* IE ve Edge için */
}

.phone-footer {
  height: 24px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  z-index: 1;
  flex-shrink: 0;
}

.simulator-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 340px;
  transition: none;
  user-select: none;
}

.simulator-header {
  width: 100%;
  background-color: #3c3c3c;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 9px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  cursor: move;
  user-select: none;
}

.simulator-header .header-left {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.simulator-header .header-center {
  flex: 3;
  display: flex;
  justify-content: center;
  align-items: center;
}

.simulator-header .header-right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.close-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
  transition: filter 0.3s;
}

.close-icon:hover {
  filter: brightness(0.8);
}

.simulator-wrapper * {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.dynamic-island {
  width: 126px;
  height: 36px;
  border-radius: 18px;
}

.header-icon-button {
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s;
  background-color: transparent;
  border: none;
  width: 18px;
}

.header-icon-button img {
  width: 18px;
  height: 18px;
}

.header-icon-button.disabled {
  filter: brightness(0.6);
  cursor: not-allowed;
}

.header-icon-button:hover {
  filter: brightness(0.8);
}

.module-dropdown-selected {
  font-family: euclid_regular, sans-serif;
  font-size: 12px;
  color: #fff;
  letter-spacing: 0.6px;
}

.module-dropdown-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.module-dropdown {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border-radius: 9px;
  cursor: pointer;
}

.module-dropdown img {
  width: 16px;
  height: 16px;
}

.module-dropdown-content {
  position: absolute;
  top: calc(100% + 15px);
  background-color: #232323;
  border-radius: 9px;
  z-index: 1000;
  padding: 6px;
  min-width: 185px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  max-height: 700px;
  overflow-y: auto;
}

.module-dropdown-item-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 3px 6px;
  margin-top: 10px;
}

.module-dropdown-item-header:first-child {
  margin-top: 0;
}

.module-dropdown-item-header span {
  font-family: euclid_semi_bold, sans-serif;
  font-size: 12px;
  color: #F5F5FF;
  letter-spacing: 0.6px;
}

.module-dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 3px 6px;
  border-radius: 5px;
  cursor: pointer;
}

.module-dropdown-item-separator {
  height: 1px;
  width: 100%;
  background-color: rgba(234, 236, 240, 0.3);
}

.module-dropdown-item:hover {
  background-color: #1C3CD5;
}

.module-dropdown-item.selected {
  background-color: #1C3CD5;
}

.module-dropdown-item span {
  font-family: euclid_regular, sans-serif;
  font-size: 12px;
  color: rgba(245, 245, 255, 0.6);
}

.module-dropdown-item.selected span {
  color: #fff;
}

.module-dropdown-item:hover span {
  color: #fff;
}

.dropdown-arrow {
  width: 16px;
  height: 16px;
  transition: transform 0.2s ease;
}

.dropdown-arrow.rotated {
  transform: rotate(180deg);
}

.current-question-index {
  font-family: euclid_regular, sans-serif;
  font-size: 12px;
  color: #F5F5FF;
  margin: 0 5px;
  text-wrap: nowrap;
}

.content-header {
  justify-content: center;
  display: flex;
  flex-direction: column;
  padding: 0 10px;
  flex-shrink: 0;
}

.content-body {
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}

.content-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-top: 1px solid #EAECF0;
  z-index: 1;
  flex-shrink: 0;
  background-color: #fff;
}

.content-description  {
  text-align: center;
  font-family: 'euclid_regular', sans-serif;
  font-size: 10px;
  line-height: 14px;
  color: #9194A3;
}

.content-title {
  font-family: 'euclid_semi_bold', sans-serif;
  font-size: 12px;
  line-height: 16px;
  color: #040C2D;
  text-align: center;
}


.progress-container {
  margin-bottom: 10px;
  display: flex;
  width: 100%;
  height: 3.5px;
  background-color: #ececec;
  align-self: center;
  margin-top: 10px;
}

.progress-bar {
  height: 100%;
  background-color: #4A68F8;
  transition: width 0.3s ease-in-out;
}

.content-footer .prev-button {
  border: 1px solid #98A2B3;
  background-color: transparent;
  color: #040C2D;
  border-radius: 9px;
  padding: 10px 20px;
  font-family: euclid_medium, sans-serif;
  outline: none;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.content-footer .next-button {
  border: 1px solid #4A68F8;
  background-color: #4A68F8;
  color: #fff;
  border-radius: 12px;
  padding: 10px 25px;
  font-family: euclid_medium, sans-serif;
  outline: none;
  font-size: 14px;
  transition: background-color 0.3s ease;
}

.content-footer .prev-button.disabled {
  border-color: #98A2B3;
  background-color: transparent;
  color: #98A2B3;
  cursor: not-allowed;
}

.content-footer .next-button.disabled {
  border-color: #a5b6ff;
  background-color: #a5b6ff;
  color: #fff;
  cursor: not-allowed;
}

.content-footer .prev-button:hover {
  background-color: #dcdcdc;
}

.content-footer .next-button:hover {
  background-color: #2f49ca;
}

.no-preview-available {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-family: euclid_regular, sans-serif;
  font-size: 12px;
  color: #9194A3;
}
</style>
